//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchRequestCardRequest,
  fetchRequestCardSuccess,
  fetchRequestCardFailure,
  updateRequestCardRequest,
  updateRequestCardSuccess,
  updateRequestCardFailure,
} from '../reducer/requestCardSlice';
import { getRequestCard, updateRequestCard } from '../api';

export function* fetchRequestCardSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    console.log('fetchRequestCardRequest saga');
    const response = yield call(
      getRequestCard,
      'request_replacement_card_options',
      accountId,
      customerId
    );

    if (response) {
      yield put(fetchRequestCardSuccess(response));
    } else {
      yield put(fetchRequestCardFailure(response));
    }
  } catch (error: any) {
    if (error.status) {
      yield put(fetchRequestCardFailure(error));
    } else {
      yield put(
        fetchRequestCardFailure(
          error.message || 'Failed to fetch card lock status.'
        )
      );
    }
  }
}

export function* updateRequestCardSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    const response = yield call(
      updateRequestCard,
      'request_replacement_card',
      accountId,
      customerId,
      requestBody
    );
    

    if (response) {
      yield put(updateRequestCardSuccess(response));
    } else {
      yield put(updateRequestCardFailure('Failed to update card lock status.'));
    }
  } catch (error: any) {
    console.log('error', error);
    yield put(
      updateRequestCardFailure(error || 'Failed to update card lock status.')
    );
  }
}

// Watch sagas
export function* watchRequestCardSagas() {
  yield takeLatest(fetchRequestCardRequest.type, fetchRequestCardSaga);
  yield takeLatest(updateRequestCardRequest.type, updateRequestCardSaga);
}
